import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  idLeadCorretor: string | undefined;
}

export interface CompartilhadosInterface {
  compartilhadoPor: string;
  corretorAtual: string;
  compartilhadoEm: string;
  idCompartilhamento: string;
  idCorretorAtual: string;
}

interface Corretor {
  id: string;
  nome: string;
  foto: string;
}

interface DataResponse {
  idLeadCorretor: string;
  idLead: string;
  corretorResponsavel: Corretor;
  corretorOrigem: Corretor;
  compartilhados: CompartilhadosInterface[];
}

export function useResponsaveis(props: Props & QueryGlobalInterface) {
  const fetchData = async () => {
    const RESPONSAVEIS = `${leadsWebEnviroment}/commom/leads/responsaveis/v1/${props.idLeadCorretor}`;
    const response = await instance.get(RESPONSAVEIS);

    return response?.data?.data?.dataResponse as DataResponse;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    onError: (error: any) => {
      toast?.error(
        `Erro ao buscar responsáveis do lead. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
